import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './Home.module.css';

const Home = () => {
  const navigate = useNavigate();
  const notionLink = 'https://cancercompass.notion.site/Cancer-Compass-Downloads-7c7c91844c474d4a8b88fd699b082f5d'

  useEffect(() => {
    // window.scrollTo(0,0)
    localStorage.clear();
  }, [])

  return (
    <section className={styles.section}>
      <div className={styles.homeCnt}>
        {/* main banner */}
        <div className={styles.titleCnt}>
          <h1 className={styles.homeTitle}>Navigation for</h1>
          <h1 className={styles.homeTitle}>Cancer Research</h1>
          <p className={styles.homeDesc}>
            Compilation of <span style={{ color: 'red', fontWeight: 'bold' }}>Consensus Cancer Genes,</span> <br />
            <span style={{ color: 'red', fontWeight: 'bold' }}>Cancer Pathway Prioritization</span>  and<br />  <span style={{ color: 'red', fontWeight: 'bold' }}>Over-representation Analysis </span><br /> for Researchers</p>
        </div>
      </div>


      {/* sub banner */}
      <div className={styles.sectionCnt}>
        <div className={styles.leftCnt}>
          <img src='/images/sample.gif' alt='sample' className={styles.img}></img>
        </div>
        <div className={styles.rightCnt}>
          <h3 className={styles.sectionTitle}>Cancer Compass <br />Data Analysis</h3>
          <p className={styles.sectionDesc}>Systematic stratification of <br />cancer signaling pathways</p>
          <div className={styles.sectionBtn} onClick={() => { alert('it has not been published yet 😊') }}>See Publication</div>
        </div>
      </div>

      {/* sub banner 2 */}
      <div className={styles.container}>
        <h1 className={styles.cntTitle}>◼️ Towards Precise and Systematic Prioritization of Signaling Pathways</h1>
        <div className={styles.section2Cnt}>
          <div className={styles.leftCnt}>
            <p>
              Signaling pathways play a critical role in many biological processes, including cell growth, differentiation, and death. Dysregulation of these pathways is often associated with the development and progression of cancer. Hence, in standard RNA-seq analysis, dysregulated signaling pathways are commonly investigated using differentially expressed genes (DEGs).
              Common methods in analyzing such pathways include over-representation analysis (ex. DAVID, CPDB) and classic statistical tests (ex. Wilcoxon rank sum test, fisher’s exact test).
            </p>
          </div>
          <div className={styles.rightCnt}>
            <p>
              The next step often entails manually prioritizing dysregulated pathways that are relevant to tumorigenesis.
              Such an approach, however, is arbitrary and non-systematic as it heavily relies on the knowledge
              of the researcher. In addition, it has the potential to introduce bias and lacks a scientific foundation.
              <span style={{ fontWeight: '800' }}>
                Our database and analytical tools allow a statistical approach to
                systematically identify pathways (gene sets) that are associated with cancer
              </span>
            </p>
          </div>
        </div>
      </div>

      {/* sub banner - fig1 */}
      <div className={styles.container}>
        <h1 className={styles.cntTitle}>◼️ Cancer Compass: A Computational Tool for Refined Cancer and Immune Pathway Annotation and Analysis</h1>
        <div className={styles.section2Cnt}>
          <p>
          Cancer Compass integrates data from 25 databases to create comprehensive consensus cancer and immune gene sets (Figure 1A). By merging 15 cancer-related and 10 immune-related databases, we identified 3,398 consensus cancer genes (CCGs) and 4,099 consensus immune genes (CIGs) based on their presence in at least two databases.  
          Its pathway prioritization tool enables rapid evaluation of gene set enrichment in cancer or immune genes, categorizing results into four confidence levels (Level 1 to Level 4) based on dynamic p-value thresholds (Figure 1B). The pathway analysis feature supports end-to-end analysis of differentially expressed genes (DEGs), prioritizing pathways by enrichment of CCGs or CIGs. Results are visualized through intuitive plots, including gene-pathway networks and 3D scatter plots, for detailed insights (Figure 1C).
          </p>
        </div>
        <p style={{fontWeight:'bold'}}>Figure. 1</p>
        <div className={styles.rightCnt} style={{ width: '100%' }}>
            <img src='/images/fig1.png' alt='desc' className={styles.img} ></img>
          </div>
      </div>

      {/* sub banner 3 */}
      <div className={styles.container}>
        <h1 className={styles.cntTitle}>◼️ Consensus Cancer Genes</h1>
        <div className={styles.section2Cnt}>
          <div className={styles.leftCnt}>
            <p>
              We began our analysis with an assumption that cancer pathways must
              be enriched with cancer genes that range from oncogenes and tumor suppressors
              to DNA repair genes, immune evasion genes, and metastasis-related genes.
              In order to capture the most comprehensive list of such cancer genes,
              we compiled data from 15 prominent databases, each with its own distinct method
              for determining cancer genes. To ensure a balance between inclusivity and sound evidence, we selected cancer
              genes that had at least two agreements between databases and designated them as our 2+ consensus cancer genes.
            </p>
            <div className={styles.sectionBtn} onClick={() => { window.open(notionLink, '_blank'); }}>
              Download CCGs</div>
          </div>
          <div className={styles.rightCnt} style={{ width: '55%' }}>
            <img src='/images/des1.png' alt='desc' className={styles.img} ></img>
          </div>
        </div>
      </div>

      {/* sub banner 3 - 1 */}
      <div className={styles.container}>
        <h1 className={styles.cntTitle}>◼️ Consensus Immune Genes</h1>
        <div className={styles.section2Cnt}>
          <div className={styles.leftCnt}>
            <p>
              Cancer cells and immune cells have a complex interaction,
              using soluble factors and direct contact to modulate the immune response,
              which leads to a cancer-friendly environment through immune tolerance and cell exhaustion.
              Understanding immune genes is key to comprehending cancer's development and progression.
              To achieve this, we integrated data from nine specific immune gene databases:
              PANTHER, CPDB, AmiGO 2, ImmPortA, InnateDB, ImmPortB, Immunome, IRIS, MAPK/NFKB network, Calvano et al.
              This integration resulted in a comprehensive assembly of 8,640 immune genes.
              Within this collection, 4,099 genes have been identified as consensus in at least two databases (2+ consensus), and 2,268 genes in three or more databases (3+ consensus).
              {/* These efforts to understand and potentially disrupt cancer-immune cell communication are vital for advancing cancer treatments, 
            aiming to undermine cancer's supportive environment and strengthen the immune response. 
            The assembled immune gene data provides essential insights for cancer research, 
            particularly in identifying biomarkers and devising new strategies to tackle cancer. */}
            </p>
            <div className={styles.sectionBtn} onClick={() => { window.open(notionLink, '_blank'); }}>Download CIGs</div>
          </div>
          <div className={styles.rightCnt} style={{ width: '55%' }}>
            <img src='/images/des.immune.png' alt='desc' className={styles.img} ></img>
          </div>
        </div>
      </div>

      {/* sub banner 4 */}
      <div className={styles.container}>
        <h1 className={styles.cntTitle}>◼️ Cancer Pathways</h1>
        <div className={styles.section3Cnt}>
          <p>
            We gathered 4,681 biological pathways from 11 commonly used databases
            (KEGG, Biocarta, Reactome, PID, Wikipathways, NetPath, INOH, Signalink, SMPDB,
            ENMN, and HumanCyc) and 33,196 gene sets (H, C1 - C8) from GSEA MSigDB.
            To systematically determine cancer pathways, we performed a hypergeometric
            test for each of the pathways (gene sets) and prioritized them into
            four levels based on the degree of cancer gene enrichment.
          </p>
          <p><span style={{ fontSize: '11px' }}>●</span> Level 1 - Cancer pathway (highest confidence)</p>
          <p><span style={{ fontSize: '11px' }}>●</span> Level 2 - Cancer pathway (high confidence)</p>
          <p><span style={{ fontSize: '11px' }}>●</span> Level 3 - Cancer pathway (moderate confidence)</p>
          <p><span style={{ fontSize: '11px' }}>●</span> Level 4 - Pathway with no significant cancer association</p>
          <img src='/images/des2.png' alt='desc' className={styles.img} style={{ width: '600px', marginTop: '10px' }}></img>
          <p style={{ marginTop: '50px' }}>
            The key differentiator of our method is the implementation of a
            dynamic p-value cutoff, based on the results of an extensive permutation test.
            The purpose of such FDR control was to minimize the risk of false discoveries derived from gene set size.
          </p>
          <img src='/images/sample2.gif' alt='desc' className={styles.img} style={{ width: '640px', marginTop: '40px' }}></img>
          {/* <div className={styles.sectionBtn} onClick={() => alert('we are currently working on it 🔥')} >See Detail</div> */}
        </div>
      </div>


      {/* sub banner 5 */}
      <div className={styles.container}>
        <h1 className={styles.cntTitle}>◼ Analytical Tools</h1>
        <div className={styles.section2Cnt}>
          <div className={styles.leftCnt}>
            <p style={{ fontSize: '28px' }}>Pathway Analysis</p>
            <p>
              Over-representation analysis based on a hypergeometric test with FDR
              control through an extensive permutation test. Enrichment of
              user-defined gene set is assessed for 4,681 biological pathways
              (KEGG, Biocarta, Reactome, PID, Wikipathways, NetPath, INOH,
              Signalink, SMPDB, ENMN, and HumanCyc) and 33,196 GSEA MSigDB gene sets.
            </p>
            <div className={styles.sectionBtn} onClick={() => { navigate('/ORA') }} style={{ margin: '30px 0 10px 0' }}>ORA for Cancer</div>
            <div className={styles.sectionBtn} onClick={() => { navigate('/ORA_immune') }} style={{ margin: '15px 0 10px 0' }}>ORA for Immune</div>
          </div>
          <div className={styles.rightCnt}>
            <p style={{ fontSize: '28px' }}>Pathway Prioritization</p>
            <p>
              Dividing the user-specified pathway (gene set)
              into four levels of cancer pathway likelihood by assessing enrichment
              of 2+ consensus cancer genes in a given pathway.
              Cutoffs for each level are dynamically
              set for the given gene set size through an extensive permutation test.
              <br />              <br />
            </p>
            <div className={styles.sectionBtn} onClick={() => { navigate('/CP') }} style={{ margin: '30px 0 10px 0' }}>PP for Cancer</div>
            <div className={styles.sectionBtn} onClick={() => { navigate('/CP_immune') }} style={{ margin: '15px 0 10px 0' }}>PP for Immune</div>
          </div>
        </div>
      </div>

    </section>
  )
}

export default Home;